<template>
    <div id='vue-material-kit-pro' :class="{'nav-open': NavbarStore.showNavbar}">
        <MainNavbar />
        <router-view />
        <MainFooterWorker />
    </div>
</template>

<script>
import MainNavbar from '@/layout/MainNavbar';
import MainFooterWorker from './layout/MainFooterWorker';

export default {
    components: {
        MainNavbar,
        MainFooterWorker,
    },
    mounted() {
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://smartcaptcha.yandexcloud.net/captcha.js?render=onload&onload=loadSmartCaptcha');
        document.head.appendChild(recaptchaScript);
    },
};


</script>
